import { kebabCase, sortBy } from 'lodash';
import { INSTAGRAM_CONTENT_TYPES, SOCIAL_PLATFORMS } from '~/constants';
import {
  CONTENT_SEARCH_DEFAULT_ORDER_BY,
  CONTENT_SEARCH_INSTAGRAM_ORDER_BY,
  CONTENT_SEARCH_INSTAGRAM_POST_ORDER_BY,
  CONTENT_SEARCH_INSTAGRAM_REEL_ORDER_BY,
  CONTENT_SEARCH_INSTAGRAM_STORY_ORDER_BY,
  CONTENT_SEARCH_ORDER_BY,
  CONTENT_SEARCH_ORDER_BY_NAMES,
  CONTENT_SEARCH_TIKTOK_ORDER_BY,
  CONTENT_SEARCH_YOUTUBE_ORDER_BY,
} from '~/hooks/useContentSearch';

const generateSortOptions = (
  options: CONTENT_SEARCH_ORDER_BY[],
  trackId?: string,
) => {
  const sortOptions = options.map((value) => ({
    friendlyValue: CONTENT_SEARCH_ORDER_BY_NAMES[value],
    value,
    trackId: trackId
      ? trackId + '-' + kebabCase(CONTENT_SEARCH_ORDER_BY_NAMES[value])
      : undefined,
  }));
  return sortBy(sortOptions, ['friendlyValue']);
};

export const getSortOptions = (
  platforms: SOCIAL_PLATFORMS[] = [],
  channels: INSTAGRAM_CONTENT_TYPES[] = [],
  trackId?: string,
) => {
  const hasOneChannel = channels.length === 1;
  const hasOnePlatform = platforms.length === 1;

  if (hasOnePlatform) {
    if (hasOneChannel && channels.includes(INSTAGRAM_CONTENT_TYPES.post)) {
      return generateSortOptions(
        CONTENT_SEARCH_INSTAGRAM_POST_ORDER_BY,
        trackId,
      );
    }

    if (hasOneChannel && channels.includes(INSTAGRAM_CONTENT_TYPES.reels)) {
      return generateSortOptions(
        CONTENT_SEARCH_INSTAGRAM_REEL_ORDER_BY,
        trackId,
      );
    }

    if (hasOneChannel && channels.includes(INSTAGRAM_CONTENT_TYPES.story)) {
      return generateSortOptions(
        CONTENT_SEARCH_INSTAGRAM_STORY_ORDER_BY,
        trackId,
      );
    }

    if (platforms.includes(SOCIAL_PLATFORMS.instagram)) {
      return generateSortOptions(CONTENT_SEARCH_INSTAGRAM_ORDER_BY, trackId);
    }

    if (platforms.includes(SOCIAL_PLATFORMS.tiktok)) {
      return generateSortOptions(CONTENT_SEARCH_TIKTOK_ORDER_BY, trackId);
    }

    if (platforms.includes(SOCIAL_PLATFORMS.youtube)) {
      return generateSortOptions(CONTENT_SEARCH_YOUTUBE_ORDER_BY, trackId);
    }
  }

  return generateSortOptions(CONTENT_SEARCH_DEFAULT_ORDER_BY, trackId);
};
